import { useState, useEffect, useContext } from 'react'
import { CommandBarButton, DefaultButton, IButtonProps, IconButton, IButtonStyles } from '@fluentui/react'
import { AppStateContext } from '../../state/AppProvider'

import styles from './Button.module.css'

interface ButtonProps extends IButtonProps {
  onClick: () => void
  text: string | undefined
}

interface ToggleButtonProps extends IButtonProps {
  id: string;
  options: Array<string>;
}

export const ProductToggleButton: React.FC<ToggleButtonProps> = ( { id, options } ) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const storageKey = `v-product-toggle_${id}`; 
  const appStateContext = useContext(AppStateContext)

  useEffect(() => {
    const storedIndex = localStorage.getItem(storageKey);
    if (storedIndex !== null) {
      setSelectedIndex(parseInt(storedIndex, 10));
    } else {
      localStorage.setItem(storageKey, "0");
    }
  }, [storageKey]);

  const handleSelect = (index: number) => {
    setSelectedIndex(index);
    localStorage.setItem(storageKey, index.toString());
    appStateContext?.dispatch({ type: 'UPDATE_CURRENT_CHAT', payload: null })
  };

  const getButtonStyles = (isActive: boolean): IButtonStyles => ({
    root: {
      backgroundColor: isActive ? "#0078d4" : "#fff",
      color: isActive ? "#ffffff" : "#323130",
      border: "1px solid #ccc",
    },
    rootHovered: {
      backgroundColor: isActive ? "#005a9e" : "#b3cce4",
      color: isActive ? "#ffffff" : "#323130",
    },
    rootPressed: {
      backgroundColor: "#0078d4",
      color: "#fff",
    },
  });

  return (
    <div style={{ display: "flex" }}>
      {options.map((product, index) => (
        <DefaultButton
          key={product}
          onClick={() => handleSelect(index)}
          styles={getButtonStyles(selectedIndex === index)}
        >
          {product}
        </DefaultButton>
      ))}
    </div>
  );
};

export const ShareButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <CommandBarButton
      className={styles.shareButtonRoot}
      iconProps={{ iconName: 'Share' }}
      onClick={onClick}
      text={text}
    />
  )
}

export const HistoryButton: React.FC<ButtonProps> = ({ onClick, text }) => {
  return (
    <DefaultButton
      className={styles.historyButtonRoot}
      text={text}
      iconProps={{ iconName: 'History' }}
      onClick={onClick}
    />
  )
}

export const CloseButton: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      className={styles.closeButtonRoot}
      iconProps={{ iconName: 'ChromeClose' }}
      onClick={onClick}
    />
  )
}

export const ChatPopupButton: React.FC<ButtonProps> = ({ onClick }) => {
  return (
    <IconButton
      className={styles.chatPopupButton}
      iconProps={{ iconName: 'Chat' }}
      onClick={onClick}
    />
  )
}